// extracted by mini-css-extract-plugin
export var animationContainer = "_hg-0";
export var asteriskIcon = "_hg-8";
export var conversationLeftSection = "_hg-4";
export var conversationListItem = "_hg-3";
export var conversationMiddleSection = "_hg-5";
export var conversationRightSection = "_hg-6";
export var detailsContent = "_hg-1";
export var listContainer = "_hg-7";
export var modalContent = "_hg-2";